export default __webpack_public_path__ + "8a5ea68c24a49052b3cc73a6fe84af96.jpg";